import { FunctionComponent, ReactElement } from 'react';
import styled from 'styled-components';
import { BaseButton } from '../../../components/DesignSystem';
import DataCardForPaper from './DataCardForPaper';

const RedScore: FunctionComponent<Record<string, never>> = (): ReactElement => {
  const ButtonContainer = styled.div`
    display: flex;
    margin-top: 40px;
    base-button {
      min-width: 286px;
    }
    //tablet or larger
    @media (min-width: 496px) {
      base-button {
        min-width: 195px;
      }
    }
  `;
  const Container = styled.div`
    display: flex;
    flex-direction: column;
    align-items: center;
    margin-top: 40px;
    base-button {
      min-width: 286px;
    }
    //tablet or larger
    @media (min-width: 496px) {
      base-button {
        min-width: 275px;
      }
    }
  `;

  const TextContainer = styled.div`
    position: relative;
    margin-bottom: 30px;
    .title {
      padding: 0px 35px;
      font-size: 20px;
      line-height: 28px;
      color: #4a4a4a;
      text-align: center;
      font-weight: bold;
      margin-bottom: 30px;
    }
    .text {
    }
  `;
  const redirectToHomePage = () => {
    window.location.replace((window as unknown as WindowWithEnv)._env_.cetelemUrl);
  };

  return (
    <Container>
      <DataCardForPaper />
      <ButtonContainer>
        <BaseButton onClick={redirectToHomePage}>Retourner à l'accueil</BaseButton>
      </ButtonContainer>
    </Container>
  );
};

export default RedScore;
